<template>
  <div>
    <div v-if="isLoading">
      <div class="text-center text-danger my-2">
        <b-spinner class="align-middle" variant="yellow" />
      </div>
    </div>
    <div v-else>
      <b-form-group>
        <b-form-checkbox
          v-for="agent in agents"
          v-model="agentFilter"
          :key="agent.value"
          :value="agent.id"
          name="flavour-3a"
          @change="onSelectedAgent"
        >
          {{ agent.nickname }}
          <span>({{ agent.acronym }})</span>
        </b-form-checkbox>
      </b-form-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "AgentsList",
  props: ["agentsSelected"],
  data() {
    return {
      agents: [],
      agentFilter: [],
      isLoading: false,
    };
  },
  watch: {
    agentsSelected: {
      handler: function (val) {
        this.agentFilter = val;
      },
      deep: true,
    },
  },
  methods: {
    getAgents() {
      this.isLoading = true;
      this.$store
        .dispatch("GET_AGENTS")
        .then((response) => {
          this.agents = response.agent;
          this.agentFilter = this.agentsSelected;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onSelectedAgent() {
      this.$emit("selectedAgent", this.agentFilter);
    },
  },

  mounted() {
    this.getAgents();
  },
};
</script>

<style></style>
